export var AnimalSoc;
(function (AnimalSoc) {
  AnimalSoc["POWER1"] = "POWER1";
  AnimalSoc["POWER2"] = "POWER2";
  AnimalSoc["POWER3"] = "POWER3";
  AnimalSoc["POWER4"] = "POWER4";
  AnimalSoc["POWER5"] = "POWER5";
  AnimalSoc["POWER01"] = "POWER01";
  AnimalSoc["POWER02"] = "POWER02";
  AnimalSoc["POWER03"] = "POWER03";
  AnimalSoc["POWER04"] = "POWER04";
  AnimalSoc["POWER05"] = "POWER05";
  AnimalSoc["POWER10"] = "POWER10";
  AnimalSoc["POWER20"] = "POWER20";
  AnimalSoc["POWER30"] = "POWER30";
  AnimalSoc["POWER40"] = "POWER40";
  AnimalSoc["POWER50"] = "POWER50";
  AnimalSoc["POWER3A"] = "POWER3A";
})(AnimalSoc || (AnimalSoc = {}));
export var PowerStatus;
(function (PowerStatus) {
  PowerStatus["Not connected"] = "not connected";
  PowerStatus["Connected"] = "connected";
  PowerStatus["Suspended"] = "suspended";
})(PowerStatus || (PowerStatus = {}));